import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Load Klaviyo — let Klaviyo's own script handle all initialization
const klaviyoScript = document.createElement('script');
klaviyoScript.src = 'https://static.klaviyo.com/onsite/js/UkcBbt/klaviyo.js?company_id=UkcBbt';
klaviyoScript.async = true;
klaviyoScript.type = 'text/javascript';
document.head.appendChild(klaviyoScript);
(function (c: any, l: any, a: string, r: string, i: string) {
  c[a] = c[a] || function () {
    ;
    (c[a].q = c[a].q || []).push(arguments);
  };
  const t = l.createElement(r);
  t.async = 1;
  t.src = 'https://www.clarity.ms/tag/' + i;
  const y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, 'clarity', 'script', 'vnlfl8bxil');
render(<App data-id="element-117" />, document.getElementById('root'));